import { PieChart, Pie, Sector } from 'recharts'
import { useTheme } from 'styled-components'

type ChartDataObject = {
  value: number
}

const RenderActiveShape = (props: {
  cx: number
  cy: number
  innerRadius: number
  outerRadius: number
  startAngle: number
  endAngle: number
  percent: number
  fillColor: string
}) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, percent, fillColor } = props
  const { colors } = useTheme()

  return (
    <g>
      <text
        x={cx}
        y={cy}
        dy={15}
        style={{ fontWeight: 600, fontSize: '30px' }}
        textAnchor="middle"
        fill={colors.baseColor[900]}
      >
        {percent * 100 ? `${(percent * 100).toFixed()}%` : '0%'}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fillColor}
      />
    </g>
  )
}

interface Props {
  data: ChartDataObject[]
}

export const Chart: React.FC<Props> = ({ data }) => {
  const { colors } = useTheme()

  const getDataValues = () => {
    const dataHasValues = data.some(dataValue => !!dataValue.value)
    if (dataHasValues) return data
    return [{ value: 0 }, { value: 100 }]
  }

  return (
    <PieChart width={200} height={200}>
      <Pie
        activeIndex={0}
        activeShape={props => <RenderActiveShape {...props} fillColor={colors.primary[500]} />}
        innerRadius={82}
        outerRadius={100}
        cx="50%"
        cy="50%"
        fill={colors.baseColor[700]}
        data={getDataValues()}
        dataKey="value"
      />
    </PieChart>
  )
}
